import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import AIAssistant from './AIAssistant';

export default function FloatingAIButton() {
  const { user } = useAuth();
  const [showAIAssistant, setShowAIAssistant] = useState(false);

  return (
    <>
      {/* Floating AI Button */}
      <button
        onClick={() => setShowAIAssistant(true)}
        className="floating-ai-button fixed bottom-24 right-4 w-14 h-14 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 z-50 flex items-center justify-center group sm:bottom-6 sm:right-6 md:bottom-8 md:right-8"
        title="AI Assistant - Ask me anything about baby items!"
      >
        {/* Bot Icon */}
        <svg 
          className="w-7 h-7 text-white transition-transform duration-300 group-hover:scale-110" 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={2} 
            d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" 
          />
          <circle cx="9" cy="9" r="1" fill="currentColor"/>
          <circle cx="15" cy="9" r="1" fill="currentColor"/>
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={2} 
            d="M9 13h6" 
          />
        </svg>
        
        {/* Pulse Animation */}
        <div className="absolute inset-0 rounded-full bg-gradient-to-r from-purple-500 to-pink-500 ai-button-pulse"></div>
        
        {/* Notification Badge (optional - can show if there are new features) */}
        <div className="absolute -top-1 -right-1 w-3 h-3 bg-green-400 rounded-full border-2 border-white"></div>
      </button>

      {/* AI Assistant Modal */}
      <AIAssistant 
        isVisible={showAIAssistant} 
        onClose={() => setShowAIAssistant(false)}
        context={{ user: user?.user_metadata }}
      />
    </>
  );
}
